"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var trim_1 = __importDefault(require("./utilities/str/trim"));
var ltrim_1 = __importDefault(require("./utilities/str/ltrim"));
var ucfirst_1 = __importDefault(require("./utilities/str/ucfirst"));
var extension_1 = __importDefault(require("./utilities/str/extension"));
var repeatsOf_1 = __importDefault(require("./utilities/str/repeatsOf"));
var removeLast_1 = __importDefault(require("./utilities/str/removeLast"));
var capitalize_1 = __importDefault(require("./utilities/str/capitalize"));
var replaceAll_1 = __importDefault(require("./utilities/str/replaceAll"));
var toCamelCase_1 = __importDefault(require("./utilities/str/toCamelCase"));
var toInputName_1 = __importDefault(require("./utilities/str/toInputName"));
var toSnakeCase_1 = __importDefault(require("./utilities/str/toSnakeCase"));
var replaceLast_1 = __importDefault(require("./utilities/str/replaceLast"));
var removeFirst_1 = __importDefault(require("./utilities/str/removeFirst"));
var replaceFirst_1 = __importDefault(require("./utilities/str/replaceFirst"));
var toStudlyCase_1 = __importDefault(require("./utilities/str/toStudlyCase"));
var readMoreWords_1 = __importDefault(require("./utilities/str/readMoreWords"));
var readMoreChars_1 = __importDefault(require("./utilities/str/readMoreChars"));
exports.default = {
    trim: trim_1.default,
    ltrim: ltrim_1.default,
    ucfirst: ucfirst_1.default,
    extension: extension_1.default,
    repeatsOf: repeatsOf_1.default,
    removeLast: removeLast_1.default,
    capitalize: capitalize_1.default,
    replaceAll: replaceAll_1.default,
    removeFirst: removeFirst_1.default,
    replaceLast: replaceLast_1.default,
    toInputName: toInputName_1.default,
    toCamelCase: toCamelCase_1.default,
    toSnakeCase: toSnakeCase_1.default,
    replaceFirst: replaceFirst_1.default,
    toStudlyCase: toStudlyCase_1.default,
    readMoreChars: readMoreChars_1.default,
    readMoreWords: readMoreWords_1.default,
};
//# sourceMappingURL=str.js.map